<template>  
     <div class="e2e-checkbox-group"> 
          <input  type="hidden" 
                  :name="fragment.groupUuid"
                  :value="fragment.groupUuid">

          <div  :fragment="fragment.content"
                :is="resolveFragmentComponentName(fragment.content)">
          </div> 
    </div> 
</template>

<script>
import { resolveFragmentComponentName } from "./output-fragment-resolver.js";

export default {
  name: "fragment-checkbox-group",
  props: ["fragment"],
  methods: {
    resolveFragmentComponentName
  }
};
</script>
 

<style scoped>
</style>